<template>
  <div class="c-tabs">
    <div class="c-tabs__tablist" role="tablist" aria-label="">
      <button
        v-for="(tab, i) in tabs"
        v-bind:aria-controls="tab.panelId"
        v-bind:aria-selected="tab.selected"
        v-bind:class="activeTab(i)"
        v-bind:key="i"
        v-bind:id="tab.tabId"
        v-bind:tabindex="tab.tabIndex"
        v-on:click="selectTab(i)"
        v-on:keyup="keyHashLookup($event.key, i)"
        ref="tab"
        class="c-tabs__tab"
        role="tab">
        {{tab.title}}
      </button>      
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SearchTablist",
  data() {
    return {
      activeIndex: 0,
      tabs: []
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    activeTab(i) {
      return (this.activeIndex === i) ? 'is-active': '';
    },
    keyHashLookup(key, index) {
      const keyHash = {
        ArrowLeft: () => {
          const leftIndex = index - 1;
          if (leftIndex >= 0) {
            this.selectTab(leftIndex);
          }
        },
        ArrowRight: () => {
          const rightIndex = index + 1;
          if (rightIndex <= this.tabs.length - 1) {
            this.selectTab(rightIndex);
          }
        }
      };

      if (!keyHash[key]) {
        return;
      }

      return keyHash[key]();
    },
    selectTab(activeIndex) {
      this.tabs.forEach((v, i) => (v.activeTab = (i === activeIndex)));
      this.$refs.tab[activeIndex].focus();
      this.activeIndex = activeIndex;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/searches/results/SearchTablist.vue